import * as configTypes from './actionTypes';

export const initialState = {
  transactions: {
    startDateToRefund: '2020/01/01',
    limit_days: {
      on_them: 60,
      on_us: 60,
    },
  },
  firebase: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case configTypes.SET_CONFIG: {
      return {
        ...state,
        ...action.payload,
        transactions: {
          ...state.transactions,
          ...action.payload.transactions,
        },
        firebase: {
          ...state.firebase,
          ...action.payload.firebase,
        },
      };
    }

    default:
      return {
        ...state,
      };
  }
};
